import ContentLoader from 'react-content-loader';

import { useRutilusQuery } from '../../../../api/graphql/useRutilusQuery';
import { ContinuousCarousel } from '../../../../components/Carousels/ContinuousCarousel/ContinuousCarousel';
import { Container } from '../../../../components/Container/Container';
import { getNodesFromConnection } from '../../../../helpers/graphql';
import {
  GetDiscoveredBrands,
  GetDiscoveredBrandsVariables,
  GetDiscoveredBrands_entry_edges_node,
  PagePopularityOrdering,
} from '../../../../interfaces/graphql';
import { getDiscoveredBrands } from '../../../../queries/rutilus/Brands';
import { BrandCard } from '../components/BrandCard';

interface IProps {
  variant: 'FeaturedBrand' | 'ActiveBrand';
  title: string;
}

const NUMBER_OF_PLACEHOLDERS = 8;
const PLACEHOLDER_ARRAY = Array.from({ length: NUMBER_OF_PLACEHOLDERS });

export const FeaturedBrandFilter: GetDiscoveredBrandsVariables = {
  filters: { published: true, orderByPopularity: PagePopularityOrdering.DESCENDING },
};

export const ActiveBrandFilter: GetDiscoveredBrandsVariables = {
  filters: { published: true, orderByLatestPost: true },
};

export const FilteredBrands = ({ variant, title }: IProps) => {
  const { data } = useRutilusQuery<GetDiscoveredBrands, GetDiscoveredBrandsVariables>(
    getDiscoveredBrands,
    {
      variables: variant === 'FeaturedBrand' ? FeaturedBrandFilter : ActiveBrandFilter,
    },
  );

  const brandNodes = getNodesFromConnection<GetDiscoveredBrands_entry_edges_node>(data?.entry);

  return (
    <Container>
      <ContinuousCarousel
        dataTestId={`${variant}-Carousel`}
        title={title}
        outerClass="mb-md"
        childrenClassName=""
      >
        {brandNodes.length
          ? brandNodes.map(brand => <BrandCard key={brand._id} brand={brand} />)
          : PLACEHOLDER_ARRAY.map((_, i) => (
              <div style={{ minWidth: 200, minHeight: 180 }} key={`placeholder-${i}`}>
                <ContentLoader
                  uniqueKey={`filteredbrands-loader-key-${i}`}
                  width={200}
                  height={180}
                  speed={2}
                  backgroundColor="#f3f3f3"
                  foregroundColor="#ecebeb"
                >
                  <rect x="0" y="0" width="200" height="180" />
                </ContentLoader>
              </div>
            ))}
      </ContinuousCarousel>
    </Container>
  );
};
